export const SET_PLAYER_DATA = 'player:set_player_data';
export const RESET_PLAYER_DATA = 'player:reset_player_data';
